










































































import { ref, createComponent, Ref, onMounted, onUnmounted, watch } from '@vue/composition-api'
import { UploadTableFile, handlePagination } from '@/service/transferList'
import { Message, MessageBox } from '@heytap/cook-ui'
import { UPLOAD_STATUS } from '@/constant'
import { getFileIcon,removeUserToken } from '@/helpers/common'
import { getFilesDetail } from '@/service/public'
export default createComponent({
    setup(props, setupContext) {
        let timer: any =null
        let dirNameTimer: any = null
        const uploadList = ref<UploadTableFile[]>([])
        const dirNames: { [key: string]: string } = {}
        const dirIds = ref<string[]>([])
        const { currentList, handleCurrentChange, pageSize, currentPageNum, updateCurrentList } = handlePagination(
            uploadList
        )
        // 获取下载中的length，长度为0 时删除cookie
        const getInProgressList=async()=>{
            const res=await (window as any).Ait.fileSystem.getDownloadList()
            let inProgressList=[]
            if(res&&res.length){
                inProgressList=res.filter(item=>item.status==="downloading")
            }
            if(!res||!res.length||!inProgressList.length){
                removeUserToken()
            }
        }
        const loadData = async () => {
            const res = await (window as any).Ait.fileSystem.refreshUploadList()
            if (res.code === 0) {
                uploadList.value = (res.data.uploadList as UploadTableFile[]).map(item => {
                    item.target = dirNames[item.dirId] || item.dirId
                    return item
                })
            } else {
                res.code===2&& clearInterval(timer)
                uploadList.value = []
            }
            dirIds.value = uploadList.value.map(item => item.dirId)
            updateCurrentList()
            // 判断上传中的长度是否为0，为0再获取下载中的length
            const uploadingList=uploadList.value.filter(item=>item.status==="uploading")
            if(!uploadingList.length){
                getInProgressList()
            }
            // (await window.Ait.fileSystem.refreshUploadList()).data.uploadList
        }
        
        const startAll = async () => {
            console.log('startAll')
            const res = await (window as any).Ait.fileSystem.resumeAllUploadFile()
            //   console.log(res);
            loadData()
        }
        const pauseAll = async () => {
            console.log('pauseAll')
            const res = await (window as any).Ait.fileSystem.pauseAllUploadFile()
            //   console.log(res);
            loadData()
        }
        const cancelAll = async () => {
            console.log('cancelAll')
            const res = await (window as any).Ait.fileSystem.removeAllUploadFile()
            //   console.log(res);
            loadData()
        }
        const pause = async row => {
            console.log('pause', row)
            // row.status = "pause";
            const res = await (window as any).Ait.fileSystem.pauseUploadFile(row)
            //   console.log(res);
            loadData()
        }
        const start = async row => {
            console.log('start', row)
            // row.status = "uploading";
            const res = await (window as any).Ait.fileSystem.resumeUploadFile(row)
            if (res.code !== 0) {
                try {
                    //   const downloadAppUrl =
                    //     window.location.origin + "/desktop/heyTap_ait.zip";
                    await MessageBox.confirm(`本地文件已损坏，请重新选择文件上传`, '提示', {
                        cancelButtonText: '取消',
                        confirmButtonText: '选择文件',
                    })
                    const res = await (window as any).Ait.fileSystem.selectFiles({
                        dirId: row.dirId,
                        realId: row.realId,
                    })
                    if (res.code !== 0) {
                        // if (res.code === 2) {
                        //   window.location.reload();
                        // } else {
                        //   // Message.error(res.message || "上传失败");
                        // }
                    } else {
                        if (res.data && res.data.failedFile && res.data.failedFile.length !== 0) {
                            // const filesName = res.data.failedFile.join();
                            // Message.error(`${filesName} 上传失败`);
                        }
                        if (
                            res.data &&
                            res.data.selected &&
                            res.data.selected.length !== 0 &&
                            res.data.failedFile &&
                            res.data.failedFile.length !== res.data.selected.length
                        ) {
                            Message.success('开始上传')
                        }
                    }
                } catch (error) {
                    if (error && error.stack) {
                        console.log(error.stack)
                    }
                }
            }
            //   console.log(res);
            loadData()
        }
        const cancel = async row => {
            //   console.log("cancel", row);
            const res = await (window as any).Ait.fileSystem.removeUploadFile(row)
            //   console.log(res);
            loadData()
        }

        const getDirNames = async () => {
            if (dirIds.value.length) {
                const res = await getFilesDetail(dirIds.value)
                if (res.code === 0) {
                    res.data.forEach(item => {
                        dirNames[item.id] = item.name
                    })
                }
            }
        }
        onMounted(async () => {
            currentPageNum.value = 1
            await loadData()
            getDirNames()
            timer= setInterval(async () => {
                loadData()
            }, 1000)
            dirNameTimer = setInterval(async () => {
                getDirNames()
            }, 5000)
        })
        onUnmounted(() => {
            clearInterval(timer)
            clearInterval(dirNameTimer)
        })
        return {
            getFileIcon,
            uploadList,
            startAll,
            pauseAll,
            cancelAll,
            pause,
            start,
            cancel,
            currentList,
            handleCurrentChange,
            pageSize,
            UPLOAD_STATUS,
        }
    },
})
